// The Monday check-in's Tab stops, in page order: every stream input, and
// each client card's notice question while it is unanswered. ONE list, so
// the row controller (check_in_controller) and the notice controller
// (check_in_notice_controller) walk the same path.
export const CHECK_IN_STOPS = ".check-in-stream-input, .check-in-notice-stop"

export function checkInStops() {
  return Array.from(document.querySelectorAll(CHECK_IN_STOPS)).filter(el => el.offsetParent !== null)
}

// The stop after `from` (before it when backwards). `from` is a stop itself.
export function checkInStopFrom(from, backwards = false) {
  const stops = checkInStops()
  const i = stops.indexOf(from)
  if (i === -1) return null
  return (backwards ? stops[i - 1] : stops[i + 1]) || null
}

// The first stop that follows a block in the page and is not inside it.
export function checkInStopAfter(block) {
  return checkInStops().find(el =>
    !block.contains(el) && (block.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)) || null
}

export function focusCheckInStop(el) {
  if (!el) return
  el.focus()
  if (el.select) el.select()
}
